// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ClientesPreencher_GenerateLinkResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /clientes_preencher/generate_link
 *
 * Returns the generated token info and the client's name and phone.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ClientesPreencher_GenerateLinkResponseDados {
token?: string
link_url?: string
cliente_nome?: string
cliente_telefone?: string
is_new_client?: boolean
}

export type ClientesPreencher_GenerateLinkResponse = ApiResponse<ClientesPreencher_GenerateLinkResponseDados>;

registerResponseContract('ClientesPreencher_GenerateLinkResponse', {
  token:            { type: 'string',  required: false },
  link_url:         { type: 'string',  required: false },
  cliente_nome:     { type: 'string',  required: false },
  cliente_telefone: { type: 'string',  required: false },
  is_new_client:    { type: 'boolean', required: false },
})
